// extracted by mini-css-extract-plugin
module.exports = {"banner":"y_bQ","banner__inner":"y_bR"};